import { useExperience } from "../../../context/ExperienceContext";
import { footerCopyByMode } from "./data/footerData";

import FooterBrand from "./components/Brand/FooterBrand.jsx";
import FooterContact from "./components/Contact/FooterContact.jsx";
import FooterMiddleCard from "./components/MiddleCard/FooterMiddleCard.jsx";
import FooterSchedule from "./components/Schedule/FooterSchedule.jsx";
import FooterBottom from "./components/Bottom/FooterBottom.jsx";
import FooterBotanical from "./components/Botanical/FooterBotanical.jsx";

import "./Footer.css";

export default function Footer() {
  const { mode } = useExperience();
  const footerCopy = footerCopyByMode[mode] || footerCopyByMode.all;

  const developmentYear = 2026;
  const currentYear = new Date().getFullYear();
  const copyrightYear =
    currentYear > developmentYear
      ? `${developmentYear}-${currentYear}`
      : `${currentYear}`;

  return (
    <footer className="site-footer">
      <div className="container">
        <FooterBrand />

        <div className="site-footer__top">
          <FooterContact mode={mode} />
          <FooterMiddleCard footerCopy={footerCopy} />
          <FooterSchedule footerCopy={footerCopy} />
        </div>
      </div>

      <FooterBotanical />

      <FooterBottom copyrightYear={copyrightYear} />
    </footer>
  );
}